import { ChangeEvent, FC, Fragment } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import QuizTypes from 'types/QuizTypes';
import MediaFormats from 'types/MediaFormats';
// Components
import { Input, Toggle } from 'components/Controls';
import ImageUpload from 'components/ImageUpload';

const ResultsFormSocialShare:FC = () => {
  const { t } = useTranslation();

  const { control, watch } = useFormContext();

  const watchedQuizType = watch('type');
  const watchedSocialShareEnabled = watch('resultsPage.socialShare.enabled');

  const isFieldsDisabled = !watchedSocialShareEnabled;

  const isPollQuizzes = [QuizTypes.Poll, QuizTypes.RankingPoll].includes(watchedQuizType);

  if ( [QuizTypes.Personality, QuizTypes.Survey].includes(watchedQuizType) ) return null;
  return (
    <Fragment>
      <div className="flex items-center mb-2">
        <span className="block text-white text-base font-semibold mr-3">{t('pages.quizForm.enabledSocialShareLabel')}</span>
        <Controller
          control={control} name="resultsPage.socialShare.enabled"
          render={({ field: { onChange, value } }) => (
            <Toggle
              id="socialShareEnabled"
              checked={value}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className="mb-4">
        <span className="block text-gray-400 text-sm mb-2 bg-gray-100 max-w-max px-2">{t('pages.quizForm.enabledSocialShareHint1')}</span>
        <span className="block text-gray-400 text-sm">{t('pages.quizForm.enabledSocialShareHint2')}</span>
      </div>
      <Controller
        control={control} name="resultsPage.socialShare.hashtags"
        render={({ field }) => (
          <Input
            {...field}
            label={t('pages.quizForm.hashtagsLabel')} id="hashtags" name="hashtags"
            helperText={t('pages.quizForm.hashtagsHint')}
            disabled={isFieldsDisabled}
          />
        )}
      />
      <Controller
        control={control} name="resultsPage.socialShare.url"
        render={({ field }) => (
          <Input
            {...field}
            label={t('pages.quizForm.socialShareUrlLabel')} id="socialShareURL" name="socialShareURL"
            helperText={t('pages.quizForm.socialShareUrlHint')}
            disabled={isFieldsDisabled}
          />
        )}
      />
      <div className="mb-4">
        <Controller
          control={control} name="resultsPage.socialShare.image"
          render={({ field }) => (
            <ImageUpload
              {...field}
              className="w-2/5"
              format={MediaFormats.SocialShare}
              label="pages.quizForm.socialShareImageLabel"
              disabled={isFieldsDisabled}
            />
          )}
        />
      </div>
      {!isPollQuizzes && (
        <div className="mb-4">
          <Controller
            control={control} name="resultsPage.socialShare.bonusValue"
            render={({ field:{ onChange, value } }) => (
              <Input
                value={value}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  const value = e.target.value ? Number(e.target.value) : e.target.value;
                  const min = Number(e.target.min);
                  const max = Number(e.target.max);
                  
                  const nextValue = typeof value === 'number'
                    ? value < min ? min : value > max ? max : value
                    : value;

                  onChange(nextValue);
                }}
                label={t('pages.quizForm.socialShareBonusValueLabel')} id="socialShareBonusValue" name="socialShareBonusValue"
                type="number"
                min={0}
                max={100000}
                disabled={isFieldsDisabled}
              />
            )}
          />
        </div>
      )}
      <span className="divider my-4" />
    </Fragment>
  )
}

export default ResultsFormSocialShare;
